// src/Components/Footer/FooterLinkColumn.tsx
import { Typography } from "antd";
import { useIntl } from "react-intl";
import { handleFooterTarget } from "./footerNav";
import { localizeCorporateUrl, type FooterLink } from "./footerConfig";
import {
  openLegalDocFromClick,
  withLangParam,
} from "../Legal/legalDocLinks";
import { legalDocFromPath } from "../../Orchestrator/Recoils/LegalDocModalAtom";

const { Title } = Typography;

interface Props {
  titleKey: string;
  links: FooterLink[];
}

export default function FooterLinkColumn({ titleKey, links }: Props) {
  const intl = useIntl();
  return (
    <>
      <Title level={4} className="footer-title">
        {intl.formatMessage({ id: titleKey })}
      </Title>
      <ul className="footer-list">
        {links.map((link) => {
          const label = intl.formatMessage({ id: link.labelKey });
          if (link.target.kind === "none") {
            return (
              <li key={link.labelKey}>
                <span className="footer-link">{label}</span>
              </li>
            );
          }
          if (link.target.kind === "external") {
            return (
              <li key={link.labelKey}>
                <a
                  href={localizeCorporateUrl(link.target.url, intl.locale)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  {label}
                </a>
              </li>
            );
          }
          // Legal docs open the in-app modal on a plain click, but render as
          // real anchors so a new-tab click (web) or the mobile WebView gets a
          // navigable, locale-tagged href (…?tab=privacy-policy&lang=ar).
          const legalDoc =
            link.target.kind === "route"
              ? legalDocFromPath(link.target.path)
              : null;
          if (link.target.kind === "route" && legalDoc) {
            return (
              <li key={link.labelKey}>
                <a
                  href={withLangParam(link.target.path, intl.locale)}
                  className="footer-link"
                  onClick={(e) => openLegalDocFromClick(e, legalDoc)}
                >
                  {label}
                </a>
              </li>
            );
          }
          return (
            <li key={link.labelKey}>
              <button
                type="button"
                className="footer-link footer-link-button"
                onClick={() => handleFooterTarget(link.target)}
              >
                {label}
              </button>
            </li>
          );
        })}
      </ul>
    </>
  );
}
